import { useAllOpinionsQuery } from 'components/Opinion/OpinionCol/OpinionCol.hooks';
import { OpinionItem } from 'components/Opinion/OpinionItem';

export const ReviewOpinions = () => {
  const { data } = useAllOpinionsQuery({
    isConfirmed: false,
    sort: 'createdAt',
  });

  return (
    <div>
      {data?.map((opinion) => (
        <OpinionItem key={opinion.id} canRead {...opinion}></OpinionItem>
      ))}
    </div>
  );
};
